<template>
    <div class="app-digi" id="full-screen">
        <div class="horizontal-layout-1" v-if="loadingGif">
            <div class="d-flex justify-content-center align-items-center w-100 h-100">
                <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="25" :dots-num="3" color="#206ad3" class="text-center d-flex w-100 mt-50 justify-content-center"/> -->
                <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
            </div>
            <div v-if="notification_call" class="checkoutLoader">
                <div class="LoaderPlacement">
                    <div class="digi-table-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 h-100" v-else>
            <!-- <div class="horizontal-layout-1" v-if="!showaccess">
                <div id="main" class="chrome scroll-new" :class="loggedIn ? 'flex-row overflow-auto' : ''" v-if="loggedIn && otpVerified && !register">
                    <div class="w-100 bg-white events-blocker" id="events-blocker" @click="toggleMenu"></div>
                    <digi-sidebar product_name="DigiHelp" @handleToggleShow="handleToggleShow"></digi-sidebar>
                    <side-bar :route_menus="route_menus" @handleToggleShow="handleToggleShow"></side-bar>
                    <div class="w-100">
                        <div class="digitop">
                            <navbar-new :toggleShow="toggleShow" product_name="DigiHelp" :auth_token="auth_token"></navbar-new>
                            <digi-navbar product_name="DigiHelp" :toggleShow="toggleShow" :auth_token="auth_token"></digi-navbar>
                        </div>
                        <div id="content-box" class="content-box" :class="{'content-boxnew':toggleShow == true}">
                            <router-view />
                            <footer-new></footer-new>
                        </div>
                    </div>
                </div>
                <div class="horizontal-layout-1" v-else-if="register || !otpVerified">
                    <div id="main">
                        <router-view/>
                    </div> 
                </div>
            </div> -->

            <!-- Restructured -->
            <div class="horizontal-layout-1 h-100" v-if="!showaccess">
                <div id="main" v-if="isChrome && loggedIn && otpVerified && !register">
                    <div class="w-100 bg-white events-blocker" id="events-blocker" @click="toggleMenu"></div>
                    <div class="main-navbar" id="main-navbar" style="z-index: 222;">
                        <Navbar product_name="DigiHelp" :toggleShow="toggleShow" :auth_token="auth_token" @SwitchCompanySuccess="SwitchCompanySuccess"/>
                        <!-- <digi-navbar product_name="DigiHelp" :toggleShow="toggleShow" :auth_token="auth_token" @SwitchCompanySuccess="SwitchCompanySuccess"></digi-navbar> -->
                    </div>
                    <div class="digicontainer" style="z-index: -1;">
                        <div class="dccontainer">
                            <div class="ps-container ps w-100">
                                <div class="bigcontainer" ref="containerDiv">
                                    <div class="content-block h-100" :class="{'content-boxnew':toggleShow == true}">
                                        <Sidebar class="d-flex flex-column flex-row-auto" product_name="DigiHelp" :route_menus="route_menus" @handleToggleShow="handleToggleShow" />
                                        <!-- <digi-sidebar class="d-flex flex-column flex-row-auto" product_name="DigiHelp" :route_menus="route_menus" @handleToggleShow="handleToggleShow"></digi-sidebar> -->
                                        <div class="p-0 position-relative" id="router-relative" style="z-index: 0;min-height: 90%;">
                                            <router-view />
                                        </div>
                                        <div style="bottom: 0 !important;">
                                            <footer-new></footer-new>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 justify-content-center animated" style="display: flex; z-index: 99999 !important;" :class="{'in-down':switch_success == false || switch_success,'d-none':!switch_success,'fadeOut': switch_success == false}" v-if="switch_success">
                        <SwitchCompanySuccess @hideSuccess="hideSuccess" :success_message="switch_comp_success_message" modal_name="switch-success" style="z-index:9999 !important" />
                    </div>
                </div>
                <!-- <div class="d-flex flex-column flex-root">
                    <div class="d-flex flex-row flex-column-fluid">
                        <div class="d-flex flex-column flex-row-auto"> 
                        <digi-sidebar roduct_name="DigiHelp" :route_menus="route_menus" @handleToggleShow="handleToggleShow"></digi-sidebar>
                        </div>
                        <div class="d-flex flex-column flex-row-fluid">

                        </div>
                    </div>

                </div> -->
                <!-- <div id="main" v-if="isChrome && loggedIn && otpVerified && !register">
                    <div class="w-100 bg-white events-blocker" id="events-blocker" @click="toggleMenu"></div>
                    <div class="main-navbar" id="main-navbar" style="z-index: 222;">
                        <digi-navbar product_name="DigiHelp" :toggleShow="toggleShow" :auth_token="auth_token"></digi-navbar>
                    </div>
                    <div class="digicontainer flex-column-fluid">
                        <div class="dccontainer">
                            <div class="ps-container ps w-100">
                                <div class="bigcontainer" ref="containerDiv">
                                    <div class="content-block h-100" :class="{'content-boxnew':toggleShow == true}">
                                        <digi-sidebar product_name="DigiHelp" :route_menus="route_menus" @handleToggleShow="handleToggleShow"></digi-sidebar>
                                        <div class="p-0 position-relative" id="router-relative" style="z-index: 0;">
                                            <router-view />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer-new></footer-new>
                </div>      -->
                <div class="horizontal-layout-1" v-else-if="register || !otpVerified">
                    <div id="main">
                        <router-view/>
                    </div> 
                </div>
            </div>


            <div class="horizontal-layout-1" v-if="showaccess">
                <div id="main" class="chrome">
                    <div class="digitop">
                        <nav-top></nav-top>
                        <navbar-new></navbar-new>
                    </div>
                    <div class="digicontainer">
                        <div class="dccontainer">
                            <section class="ps-container w-100 ps ps--theme_default">
                                <div class="bigcontainer" ref="containerDiv" id="containerDiv">
                                    <div class="content-block pl-4 pr-3">
                                        <div class="">
                                            <access-denied></access-denied>
                                        </div>
                                    </div>
                                    <div class="p-0 position-relative">
                                        <footer-bottom></footer-bottom>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <switch-accessable-company modal_name="SwitchAccessableCompany" :error_msg="error_msg" v-if="switch_accessable" @DeleteSessionToken="DeleteSessionToken"></switch-accessable-company>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
	</div>
</template>
<script>
// const Sidebar = () => import('./components/NewTheme/SideBar.vue')
// const NavbarOld = () => import('./components/NavbarOld');
const Navbar = () => import('./components/NewTheme/NavbarNew.vue')
import {Sidebar} from '@digicollect_front_end/digi-fe-library'
// import {Navbar} from '@digicollect_front_end/digi-fe-library'
// import {SwitchCompanySuccess} from '@digicollect_front_end/digi-fe-library'
import axios from "axios";
import {EventBus} from './components/eventBus/nav-bar-event';
import VueBus from 'vue-bus';
import global from "./components/global.js"
import ticket from "./components/mixins/ticket";
import notification from "./components/mixins/notification";
import { SweetModal } from 'sweet-modal-vue';
// const Navbar = () => import('./components/Navbar');
import SwitchCompanySuccess from './components/NewTheme/SwitchCompanySuccess'
import SwitchAccessableCompany from './components/alertModals/SwitchAccessableCompany'
const Foot = () => import('./components/Footer');
const AccessDenied = () => import('./components/AccessDenied');
const FooterBottom = () => import('./components/FooterBottom');
const NavTop = () => import('./components/NavTop');
const DummyFillerPage = () => import('./components/NewTheme/DummyFillerPage')
const FooterNew = () => import('./components/NewTheme/FooterNew.vue')
import firebase from 'firebase/app';
import 'firebase/messaging'
require("firebase/messaging");
require("firebase/database");
export default {
    name: 'App',
    mixins:[notification, ticket],
    data(){
        return{
            route_menus: [
                {
                    name: 'Dashboard',
                    route: '/',
                    logo: {
                        inactive: '/static/images/new-theme2024/home-line-white.svg',
                        active: '/static/images/new-theme2024/home-blue-fill.svg',
                    },
                    route_names: ['Home'],
                    permitted_roles: [],
                    selected: true,
                    toggle_submenu: false
                },
                {
                    name: 'Tickets',
                    route_names: ['TicketsList', 'PMTicketsList', 'ArchieveListView', 'TicketsCreate', 'TicketsEdit', 'TicketsServiceCreate', 'ProductTemplate', 'TicketDetails'],
                    submenus: [
                        {
                            name: 'Active Tickets',
                            route: '/ticketDetails',
                            permitted_roles: [],
                            sub_route_queries: [],
                            sub_route_names: ['TicketsCreate', 'TicketsList', 'PMTicketsList', 'TicketsEdit', 'TicketsServiceCreate', 'ProductTemplate', 'TicketDetails'],
                            sub_route_params: [],
                            // submenus: [
                            //     {
                            //         name: 'General',
                            //         route: '/settings?type=general',
                            //         selected: false,
                            //         permitted_roles: [],
                            //         submenus: [
                            //             {
                            //                 name: 'General',
                            //                 route: '/settings?type=general',
                            //                 selected: false,
                            //                 permitted_roles: [],
                            //             },
                            //             {
                            //                 name: 'Facility Management',
                            //                 route: '/settings?type=facility_management',
                            //                 selected: false,
                            //                 permitted_roles: []
                            //             },
                            //             {
                            //                 name: 'Templates',
                            //                 route: '/settings?type=templatesnew',
                            //                 selected: false,
                            //                 permitted_roles: []
                            //             }
                            //         ],
                            //     },
                            //     {
                            //         name: 'Facility Management',
                            //         route: '/settings?type=facility_management',
                            //         selected: false,
                            //         permitted_roles: []
                            //     },
                            //     {
                            //         name: 'Templates',
                            //         route: '/settings?type=templatesnew',
                            //         selected: false,
                            //         permitted_roles: []
                            //     }
                            // ],
                            selected: false
                        },
                        {
                            name: 'Archive Tickets',
                            route: '/archievetickets/',
                            sub_route_names: ['ArchieveListView'],
                            sub_route_params: [],
                            permitted_roles: [],
                            sub_route_queries: [],
                            selected: false
                        }
                        
                    ],
                    logo: {
                        inactive: '/static/images/new-theme2024/ticket_icon_white.svg',
                        active: '/static/images/new-theme2024/ticket_icon_blue.svg',
                    },
                    permitted_roles: [],
                    toggle_submenu: false
                },
                {
                    name: 'Facility Management',
                    route: '/facilitymanagement/listview',
                    route_names: ['FacilityManagement', 'CreateSecurityConcern', 'ViewSecurityConcern'],
                    logo: {
                        inactive: '/static/images/new-theme2024/hotel-line-white.svg',
                        active: '/static/images/new-theme2024/hotel-fill-blue.svg',
                    },
                    selected: false,
                    permitted_roles: [],
                    toggle_submenu: false
                },
                {
                    name: 'Settings',
                    route_names: ['Settings', 'CreateDynamicTemplate', 'EditDynamicTemplate', 'ViewDynamicTemplate', 'PreviewDynamicTemplate'],
                    submenus: [
                        {
                            name: 'General',
                            route: '/settings?type=general',
                            sub_route_queries: [{type: 'general'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: []
                        },
                        {
                            name: 'Facility Management',
                            route: '/settings?type=facility_management',
                            sub_route_queries: [{type: 'facility_management'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: []
                        },
                        {
                            name: 'Templates',
                            route: '/settings?type=templatesnew',
                            sub_route_queries: [{type: 'templatesnew'}],
                            sub_route_params: [],
                            sub_route_names: ['Settings'],
                            selected: false,
                            permitted_roles: []
                        }
                    ],
                    logo: {
                        inactive: '/static/images/new-theme2024/settings-icon-white.svg',
                        active: '/static/images/new-theme2024/settings-white.svg',
                    },
                    permitted_roles: [],
                    toggle_submenu: false
                },
            ],
            fcmToken: "",
            firebaseServerKey: "AAAAbYnlazc:APA91bHIjq3SWC3cEyTPmxipH3jg_HDG5DDksHOZbpCbi4o9ZxU6Jm259Fdf-URMogP5w_ebYvghDd7HqpPcNZud3FcSqo_RlAK4vK0tsoA0hGxQiktSFFUlrWtmHVf4hsv2hDSUQztZ",
            loadingGif: true,
            showaccess:false,
            status_code: null,
            loggedIn: false,
            otpVerified: false,
            registered: true,
            register: false,
            isTablet: false,
            isIpad: false,
            loadingApp: false,
            mobileView: false,
            warning_msg: '',
            selected_ticket_id: '',
            user_has: '',
            profile_pic: '',
            organization_name: '',
            auth_token: '',
            toggleShow: false,
            isChrome: "chrome",
            isExplorer: "explorer",
            switch_success: false,
            switch_comp_success_message: '',
            new_token: "",
            error_msg: '',
            switch_accessable: false
        }
    },
    components:{
        DummyFillerPage,
        // NavbarNew,
        Sidebar,
        FooterNew,
        Navbar,
        Foot,
        AccessDenied,
        FooterBottom,
        NavTop,
        SweetModal,
        SwitchCompanySuccess,
        VueBus,
        SwitchAccessableCompany
        // 'digi-sidebar': DigiCollectLibrary.Sidebar,
        // 'digi-navbar': DigiCollectLibrary.Navbar
    },
    methods:{
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
           	document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                window.location.href = global.HELP_URL;
            }, 500);
            EventBus.$emit('ZindexChangeEnd')
        },
        SwitchCompanySuccess(message){
            try{
                this.new_token = message.token
                this.switch_comp_success_message = message.message
                this.switch_success = true
                setTimeout(() => {
                    this.$modal.show('switch-success');
                    EventBus.$emit('ZindexChangeStart')
                }, 500);
            } catch(err){
                console.log(err)
            }
        },
        handleToggleShow(show_name){
            this.toggleShow = show_name
        },
        toggleMenu(){
            // setTimeout(() => {
            //     console.log(document.getElementById('mobile_menu').classList)
            //     document.getElementById('mobile_menu').classList.add('mobile_menu_active')
            //     console.log(document.getElementById('mobile_menu').classList)
            // }, 10);
            this.toggleShow = false
            document.getElementById('events-blocker').classList.toggle('events_blocker_active')
            this.$bus.emit('handleMobileMenu')
            EventBus.$emit('handleMobileMenu')
        },
        subscribeTokenToTopic(token) {
            // let topic = this.loggedInUser.outlet_id + (this.loggedInUser.role == 'default_manager' ? 'manager' : 'waiter')
            fetch('https://iid.googleapis.com/iid/v1/'+this.fcmToken+'/rel/topics/'+this.user_id, {
                method: 'POST',
                headers: new Headers({
                'Authorization': 'key='+this.firebaseServerKey
                })
            }).then(response => {
                if (response.status < 200 || response.status >= 400) {
                throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
                }
                console.log('Subscribed to "'+this.user_id+'"');
            }).catch(error => {
                console.error(error);
            })
        },
        // subscribeTokenToOrder(token) {
        //     let topic = this.loggedInUser.outlet_id
        //     fetch('https://iid.googleapis.com/iid/v1/'+this.fcmToken+'/rel/topics/'+topic, {
        //         method: 'POST',
        //         headers: new Headers({
        //         'Authorization': 'key='+this.firebaseServerKey
        //         })
        //     }).then(response => {
        //         if (response.status < 200 || response.status >= 400) {
        //         throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
        //         }
        //         console.log('Subscribed to "'+topic+'"');
        //     }).catch(error => {
        //         console.error(error);
        //     })
        // },
        async unSubscribeTokenToTopic() {
            // let topic = this.loggedInUser.outlet_id + (this.loggedInUser.role == 'default_manager' ? 'manager' : 'waiter')
            let params = {
                "to": `/topics/${this.user_id}`,
                "registration_tokens": [this.fcmDetails.fcm_token]
            }
            fetch('https://iid.googleapis.com/iid/v1:batchRemove',{
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'key='+this.fcmDetails.fcm_server_key
                }),
                body: JSON.stringify(params)
            }).then(response => {
                console.log('UnSubscribed from "'+this.user_id+'"');
                if (response.status < 200 || response.status >= 400) {
                throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
                }
            }).catch(error => {
                console.error(error);
            })
        },
        async sendNotifications() {
            const config = {
                apiKey: "AIzaSyBWEqLS-P6JjwKcisUYNAgZmpcL--u09qA",
                authDomain: "digicrm-8aea4.firebaseapp.com",
                databaseURL: "https://digicrm-8aea4.firebaseio.com",
                projectId: "digicrm-8aea4",
                storageBucket: "digicrm-8aea4.appspot.com",
                messagingSenderId: "470464949047",
                appId: "1:470464949047:web:50022a33345733340a88b2",
                measurementId: "G-H2W1YNW57V"
            };
            let fire = firebase.initializeApp(config);

            const messaging = firebase.messaging();
            Notification.requestPermission().then(function(permission) { console.log('permiss', permission)});
            try {
                const oldToken = this.fcmToken;
                const currentToken = await messaging.getToken({ vapidKey: "BAqQfu09znIYuUNxsjkx3s96hmo0ooPo7vrPAoGqeB0j0iBPSL0iKyOM2BN4bx6VRuAhR9BplPzsPyOgKlXgDHY" });
                this.fcmToken = currentToken;
                let param = {
                    fcm_token: this.fcmToken,
                    fcm_server_key: this.firebaseServerKey
                }
                this.$store.commit('setFCMDetails', param)
                if (oldToken != this.fcmToken) {
                axios.put(global.ADMIN_API + "/internal/fcm/token", { token: this.fcmToken, session_id: this.session_id })
                    .then(res => {
                    if (res.data.status_id == 1) {
                        // if(this.loggedInUser.role != 'default_order_receiver'){
                            this.subscribeTokenToTopic()
                        // }
                        // let is_b2c_flow = localStorage.getItem('is_b2c');
                        // console.log("is_b2c_flow", is_b2c_flow)
                        // if(is_b2c_flow == 'false' || is_b2c_flow == false){
                        //     this.subscribeTokenToOrder();
                        // }
                    }
                    })
                    .catch(err => {
                        console.log(err);
                    });
                    if(this.loggedInUser.user_role == 'owner' && !this.mobileView){
                        this.subscribeTokenToTopic()
                    }
                    // let is_b2c_flow = localStorage.getItem('is_b2c');
                    // console.log("is_b2c_flow", is_b2c_flow)
                    // if(is_b2c_flow == 'false' || is_b2c_flow == false){
                    //     this.subscribeTokenToOrder();
                    // }
                }
            } catch (err) {
                console.error("Unable to retrieve token.", err);
            }
            messaging.onMessage(async payload => {
                EventBus.$emit('RecallFBNotification')
                let body = payload.data
                if(!document.hidden){
                    this.$toasted.show(payload.notification.title,{
                        theme: "toasted-primary",
                        position: "top-center",
                        className: "fw-600 error",
                        duration: 10000,
                        action : {
                            text: 'Click',
                            onClick : async () => {
                                let res = await this.ChangeReadStatus({
                                    notifications: [payload.data.notification_id]
                                })
                                if(body.goto == 'comments screen') {
                                    if(this.$route.path.startsWith('/ticketdetails/')) {
                                        if(this.$route.params && this.$route.params.id != '') {
                                            EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                active_tab: 'comments',
                                            });
                                        } 
                                        else{
                                            let params = {
                                                ticket_id: body.ticket_id,
                                                ticket_number: body.ticket_number.slice(1,),
                                                is_parent_ticket: false,
                                                subject: body.title,
                                                approval: false,
                                            }
                                            this.$router.push({ path: "/ticketdetails/" + body.ticket_id });
                                            setTimeout(() => {
                                                EventBus.$emit("tabactivate", params);
                                            }, 1000);
                                            setTimeout(() => {
                                                EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                    active_tab: 'comments',
                                                });
                                            }, 2000);
                                        }
                                    }
                                    else{
                                        let params = {
                                            ticket_id: body.ticket_id,
                                            ticket_number: body.ticket_number.slice(1,),
                                            is_parent_ticket: false,
                                            subject: body.title,
                                            approval: false,
                                        }
                                        this.$router.push({ path: "/ticketdetails/" + body.ticket_id });
                                        setTimeout(() => {
                                            EventBus.$emit("tabactivate", params);
                                        }, 1000);
                                        setTimeout(() => {
                                            EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                active_tab: 'comments',
                                            });
                                        }, 2000);
                                    }
                                } else if(body.goto == 'ticket view multi screen'){
                                    this.selected_ticket_id = body.ticket_id
                                    if(body.title.endsWith('sent to you for approval.') || body.title.indexOf('edited') != -1){
                                        this.getApprovalTicketDetails(body.ticket_id)
                                    } else {
                                        this.$router.push({
                                            path: `/ticketdetails/view/${body.ticket_id}`,
                                            query: {
                                                type: 'normal_ticket'
                                            }
                                        })
                                    }
                                } else {
                                    if(this.$route.path.startsWith('/ticketdetails/')) {
                                        if(this.$route.params && this.$route.params.id != '') {
                                            EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                active_tab: 'ticket_details',
                                            }); 
                                            setTimeout(() => {
                                                EventBus.$emit("ticketFromFirebaseNotify", {
                                                    active_tab: 'ticket_details',
                                                });
                                            }, 1000);
                                        }
                                        else{
                                            let params = {
                                                ticket_id: body.ticket_id,
                                                ticket_number: body.ticket_number.slice(1,),
                                                is_parent_ticket: false,
                                                subject: body.title,
                                                approval: false,
                                            }
                                            this.$router.push({ path: "/ticketdetails/" + body.ticket_id });
                                            setTimeout(() => {
                                                EventBus.$emit("tabactivate", params);
                                            }, 1000);
                                            setTimeout(() => {
                                                EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                    active_tab: 'ticket_details',
                                                });
                                            }, 2000);
                                        }
                                    }
                                    else{
                                        let params = {
                                            ticket_id: body.ticket_id,
                                            ticket_number: body.ticket_number.slice(1,),
                                            is_parent_ticket: false,
                                            subject: body.title,
                                            approval: false,
                                        }
                                        this.$router.push({ path: "/ticketdetails/" + body.ticket_id });
                                        setTimeout(() => {
                                            EventBus.$emit("tabactivate", params);
                                        }, 1000);
                                        setTimeout(() => {
                                            EventBus.$emit("ticketFromFirebaseNotifyForComment", {
                                                active_tab: 'ticket_details',
                                            });
                                        }, 2000);
                                    }
                                } 
                            }
                        }
                    })
                }
            })
            const vm = this;
            messaging.onTokenRefresh().then(async function(permission) {
                const refreshedToken = await messaging.getToken(); 
                vm.fcmToken = refreshedToken;
            });
        },
        getApprovalTicketDetails(id){
            let payload
            if(id == undefined){
                payload = {"ticket_id": this.selected_ticket_id}
            } else {
                payload = {"ticket_id": id}
            }
            this.notification_call = true
            this.getTicketById(payload).then(response => {
                let part_name = ''
                part_name = response.response.pending_details[0].part_name
                if(response.status_id == 1){
                    if(id == undefined){
                        this.$router.push({
                            path: `/ticketdetails/view/${this.selected_ticket_id}`,
                            query: {
                                type: 'review_ticket',
                                part_name: part_name,
                                part_status: 'Review'
                            }
                        })
                        if(this.$route.path.startsWith('/ticketdetails/view/')){
                            EventBus.$emit('UpdateAppRejView')
                        }
                    } else {
                        this.$router.push({
                            path: `/ticketdetails/view/${id}`,
                            query: {
                                type: 'review_ticket',
                                part_name: part_name,
                                part_status: 'Review'
                            }
                        })
                        if(this.$route.path.startsWith('/ticketdetails/view/')){
                            EventBus.$emit('UpdateAppRejView')
                        }
                    }
                } else {
                    this.notification_call = false
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.isUploadingInProgress = false
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }).catch(err => {
                this.notification_call = false
                if(err.hasOwnProperty('reason')){
                    this.warning_msg = err.reason;
                } else {
                    this.warning_msg = err;
                }
                this.$refs.warning_modal.open();
                setTimeout(() => this.$refs.warning_modal.close(), 2000);
            })
            this.notification_call = false
        },
        // Geting Logged In User and Set Token
        getLoggedInUser() {
            this.$http.get(global.ADMIN_API + "/auth/get_loggedin_user").then(response => {
                // this.loadingGif = false;
                if (response.data.status_id == 1) {
                    this.loggedIn = true;
                    this.showAccess = false;
                    axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                    this.$store.commit('setSessionId', response.data.response.session_id)
                    this.$store.commit('setUserId', response.data.response.user_id)
                    if (response.data.response.is_verified) {
                        this.otpVerified = true;
                        this.user_has = response.data.response.user_has;
                        this.profile_pic = response.data.response.profile_pic;
                        this.organization_name = response.data.response.organization_name;
                        this.registerInterceptors()
                        this.loadLoggedInUser()
                    } else {
                        this.$router.push("/verifyOtp");
                    }
                    this.sendNotifications()
                } else {
                    this.loggedIn = false;
                    let routePath = this.$route.path.split("/")[1];
                    switch (routePath) {
                        case "register":
                        case "registerInvited":
                            break;
                        default:
                        window.location.href = global.HELP_URL;
                    }
                }
            }).catch(error => {
                    console.log(error)
                // if (error.response.status == 403) {
                    // this.loadingApp = false
                    // this.loadingGif = false;
                    // this.showaccess = true
                    // this.$router.push({
                    //     name: "AccessDenied"
                    // })
                    this.$cookie.delete("Token", {
                        domain: "digicollect.com",
                    });
                    var res = document.cookie;
                    var multiple = res.split(";");
                    for(var i = 0; i < multiple.length; i++) {
                        var key = multiple[i].split("=");
                        document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                    setTimeout(() => {
                        window.location.href = global.HELP_URL + '/login';
                    }, 500);
                // }
            });
        },
        DeleteSessionToken(){
            this.$cookie.delete("Token");
            this.$cookie.delete('Token', {
                domain: 'digicollect.com'
            });
            this.$cookie.delete('Token', {
                domain: '.digicollect.com'
            });
            this.$cookie.delete('Token', {
                domain: '.digicollect.com',
                path: '/'
            });
            this.$cookie.delete('Token', {
                domain:document.location.hostname,
                path:document.location.pathname
            });
            this.$cookie.delete('Token', {
                domain:document.location.hostname,
            });
            this.$cookie.delete('Token', {
                path:document.location.pathname
            });
            this.$cookie.delete('Token', {
                path: '/'
            });
            console.log('deleting Token')
            var res = document.cookie;
            var multiple = res.split(";");
            for(var i = 0; i < multiple.length; i++) {
                var key = multiple[i].split("=");
                document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
            }
            setTimeout(() => {
                window.location.href = global.HELP_URL + '/login?redirect_to='+ window.location.href ;
                console.log('deleting Token login')
            }, 500);
        },
        loadLoggedInUser() {
            this.$http.get("/users/get_user_details")
            .then(response => {
                if(response.data.response){
                    this.showAccess = false;
                    this.loadingGif = false;
                    let userDetails = response.data.response.user_details
                    let companyDetails = response.data.response.company_details
                    let loggedInUser = {
                        can_create_ticket:response.data.response.can_create_ticket,
                        service_ticket_required:response.data.response.service_ticket_required,
                        company_name:companyDetails.company_name || '',
                        company_id:companyDetails.company_id || '',
                        currency:response.data.response.currency,
                        session_id:response.data.response.session_id,
                        address: userDetails.address || '',
                        user_id: userDetails.user_id || '',
                        email: userDetails.email_id || '',
                        branch:userDetails.branch || '',
                        full_name: userDetails.full_name || '',
                        phone: userDetails.phone_number || '',
                        // profile_pic: userDetails.profile_pic || '',
                        department:userDetails.department || '',
                        user_role:userDetails.user_role,
                        user_roles:response.data.response.user_roles,
                        organization_name: this.organization_name,
                        user_has: this.user_has || '',
                        profile_pic: this.profile_pic || ''
                    }
                    this.$store.commit('setLoggedInUser', loggedInUser);
                    this.$http.defaults.headers.common.SessionID = this.loggedInUser.session_id || '';
                    this.registerInterceptors();
                    
                    // this.getGeneralDetails();
                }
                else if(response.data.reason){
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
            .catch(error => {
                console.log(error)
                // if(error.response.status == 403){
                    // this.loadingApp = false
                    // this.loadingGif = false;
                    // this.showaccess = true
                    // this.$router.push({
                    //     name: "AccessDenied"
                    // })
                    // this.warning_msg = error
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    // }, 3000);
                    this.$cookie.delete("Token", {
                        domain: "digicollect.com",
                    });
                    var res = document.cookie;
                    var multiple = res.split(";");
                    for(var i = 0; i < multiple.length; i++) {
                        var key = multiple[i].split("=");
                        document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                    setTimeout(() => {
                        window.location.href = global.HELP_URL + '/login';
                    }, 500);
                    
                // }
            })
	  	}, 
        // async loadLoggedInUser() {
        //     this.$http.get("/get_loggedin_user")
        //     .then(response => {
        //         let userDetails = response.data.response
        //         let loggedInUser = {
        //             access_level: userDetails.access_level,
        //             company_type: userDetails.company_type,
        //             address: userDetails.address,
        //             admin_id: userDetails.admin_id,
        //             designation: userDetails.designation,
        //             email: userDetails.email,
        //             branch:userDetails.branch,
        //             department:userDetails.department,
        //             first_name: userDetails.first_name,
        //             full_name: userDetails.full_name,
        //             gender: userDetails.gender,
        //             is_active: userDetails.is_active,
        //             is_admin: userDetails.is_admin,
        //             is_authorized: userDetails.is_authorized,
        //             is_superuser: userDetails.is_superuser,
        //             last_name: userDetails.last_name,
        //             phone: userDetails.phone,
        //             profile_pic: userDetails.profile_pic,
        //         }
        //         this.$store.commit('setLoggedInUser', loggedInUser);
        //         this.showaccess = false
        //     })
        //     .catch(error => {
        //         if(error.response.status == 403){
        //             this.loadingApp = false
        //             this.showaccess = true
        //             this.$router.push({
        //                 name: "AccessDenied"
        //             })
        //         }
        //     })
	  	// },
        getGeneralDetails(){
            this.$http.post('/settings/get_all_settings_by_type',{settings_type:'all'})  
            .then(response => {
                if(response.data.response){
                    let generalDetails = response.data.response
                    if(generalDetails){
                        generalDetails['namingConventionOfProducts'] = generalDetails.naming_convention_of_products.naming_convention_of_products
                        generalDetails['successImage'] = generalDetails.image_for_success_message.url
                        generalDetails['failureImage'] = generalDetails.image_for_failure_message.url
                    }

                    this.$store.commit('setGeneralSettings', generalDetails);
                }
            })
        },
        registerInterceptors() {
            this.$http.interceptors.request.use(
                config => {
                    if (this.$cookie.get('Token')) {
                        config.headers.common.Authorization = this.$cookie.get(
                            'Token'
                        )
                    }
                    return config
                },
                error => {
                    return Promise.reject(error)
                }
            )
            this.$http.interceptors.response.use(undefined, err => {
                if(err.response.status == '403') {
                    //this.switch_accessable = true
                    //this.error_msg = err.response.data.reason || '-'
                    // setTimeout(() => {
                    //     this.$modal.show('SwitchAccessableCompany')
                    // }, 500);
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    this.$cookie.delete('Token', {
                        domain: '.digicollect.com'
                    });
                    this.$cookie.delete('Token', {
                        domain: '.digicollect.com',
                        path: '/'
                    });
                    this.$cookie.delete('Token', {
                        domain:document.location.hostname,
                        path:document.location.pathname
                    });
                    this.$cookie.delete('Token', {
                        domain:document.location.hostname,
                    });
                    this.$cookie.delete('Token', {
                        path:document.location.pathname
                    });
                    this.$cookie.delete('Token', {
                        path: '/'
                    });
                    var res = document.cookie;
                    var multiple = res.split(";");
                    for(var i = 0; i < multiple.length; i++) {
                        var key = multiple[i].split("=");
                        document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                    setTimeout(() => {
                        window.location.href = global.HELP_URL + '/login';
                    }, 500);
                } else {
                    // this.$log.error(err)
                    return Promise.reject(err)
                }
            })
        },
        hideaccessdenial() {
            this.showaccess = false
            this.$cookie.delete('Token', {domain: 'digicollect.com'});
            window.location.href = global.AUTH_URL+"?redirect_to="+global.HELP_URL;
        },
	  	load() {
			if(this.$cookie.get('Token',{domain:"digicollect.com"})) {
				this.$http.defaults.headers.common.Authorization = this.$cookie.get('Token');
				// this.$router.push('/');
                if (this.$route.path == "/subscription") {
                    this.$router.push("/");
                }
			} else {
				window.location.href = global.HELP_URL;
			}
			this.getLoggedInUser();
	  	},
        scrollToBottom(){
            this.$nextTick(function () {
                this.$refs.containerDiv.scrollTop = 10000;
            });
        },
        handleStyles () {
            // Red style to the body tag for the home page
            if (['/subscription'].includes(this.$route.path)) document.body.className = 'bg-white'
            // Pink style to the body tag for all other pages
            else if (document.body.classList.contains('bg-white')) document.body.className = 'bg-white'
        },
        scrollToTop() {
			this.$nextTick(function(){
                this.$refs.containerDiv.scrollTop = 0;
                window.scrollTo(0,0);
			})
		},
        scrollToTopPhone() {
			this.$nextTick(function(){
                this.$refs.containerDiv.scrollTop = 800;
                window.scrollTo(800,0);
			})
		}
    },
    computed: {
        session_id() {
			return this.$store.getters.session_id
		},
        user_id() {
			return this.$store.getters.user_id
		},
		loggedInUser() {
			return this.$store.getters.loggedInUser
		},
        userSettings() {
            return this.$store.state.store.userSettings
        },
        getGeneralSettings() {
            return this.$store.state.store.getGeneralSettings
        },
        crmDetails() {
            return this.$store.state.store.crmDetails
        },
        fcmDetails() {
            return this.$store.getters.fcmDetails;
        }
	},
    watch: {
        '$route' (to,from) {
            this.handleStyles()
            console.log("stage1")
            if (to.path != "/register" && from.path == "/login" && !this.$cookie.get("Token")) {
                console.log("stage2")
                if (window.location.pathname != '/') {
                    console.log("stage3")
                    if(this.$route.query.hasOwnProperty('redirect_to')) {
                       
                        // this.$router.push(window.location.href).catch((errr) => {
                        //     this.$router.push(window.location.href)
                        // });
                    } else {
                        console.log("stage4")
                        this.$router.push("/login?redirect_to=" + window.location.href).catch((errr) => {
                            this.$router.push("/login?redirect_to=" + window.location.href)
                        });
                    }
                } else {
                    console.log("stage5")
                    this.$router.push("/login").catch((errr) => {
                        this.$router.push("/login")
                    });
                }
            }
        },
        "$route.path": function (path) {
            if (this.$cookie.get("Token") && path == '/register') {
                this.otpVerified ? this.$router.push("/") : this.$router.push("/verifyOtp");
            }
            if (this.$cookie.get("Token") && path == '/verifyOtp') {
                this.otpVerified ? this.$router.push("/") : this.$router.push("/verifyOtp");
            }
            if ( this.$cookie.get("Token") && path == "/subscription") {
                this.$router.push("/");
            }
        },
        isIpad(){
            if(isTablet){
                this.isIpad = true
            }
            else{
                this.isIpad = false
            }
        }
    },
	async mounted() {
        EventBus.$on('ZindexChangeStart', () => {
            console.log("ZindexChangeStart")
            document.getElementById('mobile_menu').style.zIndex = '0'
            document.getElementById('main-navbar').style.zIndex = '-1'

        })
        EventBus.$on('ZindexChangeEnd', () => {
            document.getElementById('main-navbar').style.zIndex = '222'
            document.getElementById('mobile_menu').style.zIndex = '9'
        })
        // EventBus.$on('toggleShow', toggleShow => {
        //     this.toggleShow = toggleShow
        // })
        // this.$bus.on('UnSubscribe', () => {
        //     this.unSubscribeTokenToTopic();
        // })
        this.auth_token = this.$cookie.get('Token')
        // setTimeout(() => {
            if (this.$cookie.get("Token")) {
                console.log(this.$route.path == "/register" || this.$route.path == "/login" || this.$route.path == "/subscription")
                if (this.$route.path == "/register" || this.$route.path == "/login" || this.$route.path == "/subscription") {
                    this.$router.push("/");
                    console.log(this.$route.path == "/register" || this.$route.path == "/login" || this.$route.path == "/subscription")
                }
                // this.getLoggedInUser();
                this.load()
            } else {
                this.loadingGif = false;
                this.register = true;
                if (window.location.pathname != '/') {
                    if(this.$route.query.hasOwnProperty('redirect_to')) {

                        // this.$router.push(window.location.href).catch((errr) => {
                        //     this.$router.push(window.location.href)
                        // });
                    } else {
                        this.$router.push("/login" ).catch((errr) => {
                            this.$router.push("/login")
                        });
                        // this.$router.push("/login?redirect_to=" + window.location.href).catch((errr) => {
                        //     this.$router.push("/login?redirect_to=" + window.location.href)
                        // });
                    }
                } 
                else {
                    this.$router.push("/login").catch((errr) => {
                        this.$router.push("/login")
                    });
                }
            }
        // }, 500);
        let browserLang = navigator.language.split('-')[0]
        localStorage.setItem('language', browserLang)
        localStorage.getItem('language');
        this.handleStyles()
		EventBus.$on("scrollToTop", () => this.scrollToTop());
        EventBus.$on("scrollToBottom", () => this.scrollToBottom());
        EventBus.$on("scrollToTopPhone", () => this.scrollToTopPhone());
        const userAgent = navigator.userAgent.toLowerCase();
        this.isTablet = /(iphone|ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        // if(this.isTablet){
        //     if(window.innerHeight > window.innerWidth){
        //         document.getElementsByTagName("body")[0].style.transform = "rotate(90deg)";
        //         document.getElementsByTagName("body")[0].style.width = window.innerWidth;
        //         document.getElementsByTagName("body")[0].style.height = window.innerHeight;
        //         document.getElementsByTagName("body")[0].style.overflowX = "hidden !important";
        //         document.getElementsByTagName("body")[0].style.position = "absolute";
        //         document.getElementsByTagName("body")[0].style.top = "20px !important";
        //         document.getElementsByTagName("body")[0].style.left = "50px !important";
        //     }
        // }
        EventBus.$on('UnSubscribe', () => {
            this.unSubscribeTokenToTopic();
        }) 
        // this.$bus.on('UnSubscribe', () => {
        //     this.unSubscribeTokenToTopic();
        // })
        EventBus.$on('EventBlocker', () => {
            document.getElementById('events-blocker').classList.toggle('events_blocker_active')
        })
        this.$bus.on('EventBlocker', () => {
            document.getElementById('events-blocker').classList.toggle('events_blocker_active')
        })
    },
    created() {
        // try{
        //     firebase
        //         .messaging()
        //         .requestPermission()
        //         .then(() => {
        //             console.log('Notifications permission granted.')
        //             return firebase
        //                 .messaging()
        //                 .getToken()
        //                 .then((token) => {
        //                     console.log(token)
        //                 })
        //                 .catch((err) => {
        //                     console.log('Unable to get token', err)
        //                 })
        //             })
        // } catch(err) {
        //     console.log(err)
        // }
    },
    destroyed(){
        EventBus.$off('scrollToTop')
        EventBus.$off('scrollToBottom')
        EventBus.$off('scrollToTopPhone')
    },
}
</script>
<style scoped>
/* html, body {
    height: 100%;
    margin: 0;
}

#main {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.digicontainer {
    flex: 1;
}

.dccontainer, .ps-container, .bigcontainer, .content-block {
    display: flex;
    flex-direction: column;
    flex: 1;
}

#router-relative {
    flex: 1;
}

footer-new {
    position: relative;
    clear: both;
    background-color: #f8f9fa;
    padding: 10px;
    text-align: center;
} */

.ps {
  position: relative;
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}
.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}
.ps {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}
.ps-container {
  position: relative;
}
.access-denied-alert {
    position: relative !important;
    top: 30% !important;
    justify-content: center !important;
    display: flex !important;
    font-size: 18px;
    text-align: center;
    color: #0d84f2;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 220px;
    position: relative;
    background: #ffffff;
    -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    -moz-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=3, MakeShadow=true, ShadowOpacity=0.30);
    -ms-filter: "progid:DXImageTransform.Microsoft.Blur(PixelRadius=3,MakeShadow=true,ShadowOpacity=0.30)";
    zoom: 1;
    border-radius: 18px;
    width: 50%;
    margin: 0 auto;
}
.scroll-new-custom{
    border: 1px solid #b2bec3;
    overflow-y: scroll;
    width: 100%;
    height: max-content;
}

.access-denied-alert span {
    justify-content: center !important;
    display: block !important;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
}
.access-denied-alert span img {
    width: 40px;
}
.overflow-hidden{
    overflow: hidden !important;
}
.transform-screen{
    transform: rotate(90deg);
}
#full-screen:fullscreen {
	width: 100%;
	height: 100%;
}

/* prefix for Chrome & Safari */
#full-screen:-webkit-full-screen {
	width: 100%;
	height: 100%;
}

.fw-600{
    font-weight: 600 !important;
}
.page-layout.blank{
    margin-left: 0px !important;
    margin-right: 0px !important;
}
.content-block{
    margin-left: 93px;
    margin-right: 15px;
    margin-top: 90px;
}
.events-blocker{
    position: fixed;
    top: 0px;
    z-index: 99998;
    height: 100%;
    background: rgba(0, 0, 0, 0.5) !important;
    transform: translate(-100%);
}
.events_blocker_active{
    transform: translate(0%);
}
.content-boxs{
    margin-left: 0px !important;
}

.content-boxnew{
    margin-left: 250px !important;
}
@media screen and (max-width: 992px) {
    .content-block{
        margin-left: 12px;
        margin-right: 12px;
    }
    .content-boxnew{
        margin-left: 0px !important;
    }
    .page-layout.blank{
        margin-left: 0px !important;
    }
}.flex-column-fluid {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
}


</style>